module.exports = __webpack_public_path__ + "static/media/pro-detail-parallex.aa40cc6e.jpg";